module.exports = __webpack_public_path__ + "img/cashboy.png";